import type { enUi } from "./en-ui";

export const deUi = {
  // Launcher: boot, loading and error recovery.
  "ui.cheatCodeAccepted": "CHEAT-CODE AKZEPTIERT",
  "ui.accessingMassifDeepSpaceNetwork":
    "VERBINDE MIT MASSIF DEEP SPACE NETWORK...",
  "ui.640kMemoryOk": "640K SPEICHER OK",
  "ui.loadingScrumExe": "LADE SCRUM.EXE...",
  "ui.loadingSectorArt": "LADE SEKTORGRAFIK...",
  "ui.diskReadError": "LESEFEHLER",
  "ui.abortRetryFail": "ABBRECHEN, WIEDERHOLEN, AUFGEBEN?",
  "ui.retry": "WIEDERHOLEN",
  "ui.abort": "ABBRECHEN",

  // Launcher: controls and language menu.
  "ui.showControls": "Menü anzeigen",
  "ui.hideControls": "Menü ausblenden",
  "ui.language": "Sprache",
  "ui.soundOff": "Ton aus",
  "ui.soundOn": "Ton an",
  "ui.fullscreen": "Vollbild",
  "ui.exitFullscreen": "Vollbild verlassen",
  "ui.exit": "Beenden",

  // Game: resume choices, dialogue and inventory controls.
  "ui.continue": "Fortsetzen",
  "ui.newGame": "Neues Spiel",
  "ui.textSpeed": "TEXTTEMPO",
  "ui.more": "Weiter...",
  "ui.mancomb": "Mancomb",
  "ui.useWith": "{item} mit {target} benutzen",
} satisfies Record<keyof typeof enUi, string>;
